
TPS.PromotionPage = {
    termTextWrapperSel: '.terms-text-wrapper',
    registrationModalSel: '#promo-register-form-modal',
    shareModalSel: '#promo-share-form-modal',
    errorBlockSelector: '#error-callout',
    successBlockSelector: '#success-callout',
    promotionGuid: jQuery("#promotionGuid").val(),
    formParentSelector: null,
    formInner: '.landing-page-form-inner',
    formExtraFieldsSelector: '.tps-additional-fields',
    submitOverlaySelector: '.submit-overlay',
    vehicleContentSelector: '#vehicle-detail-content',
    vehcielModalSel: '#vehicle-list-modal',
    culture: jQuery('#lng').val(),
    preferredDealerPanel: null,
    preferredDealerList: [],
    partners: null,
    sponsoredPartners: null,
    hasIdMe: false,
    isHotel: false,
    init: function (formWrapper, idMe, isHotel) {

        TPS.Util.loadWebserviceJS('CMSApp.AV.API.Promotion');

        TPS.PromotionPage.isHotel = isHotel;

        if (TPS.PromotionPage.isHotel) {
            TPS.Util.loadWebserviceJS('CMSApp.AV.API.HotelPromotion');

            // set culture for datepicker
            var _currentCulture = $('#lng').val();
            TPS.Forms.setDatePickerRegion(_currentCulture);
            // bind the jquery ui datepicker to
            // these fields when it is a hotel PTO
            $('#DriveStartDate').datepicker();
            $('#DriveEndDate').datepicker();

        }

        $(document).on('click', '[href="#"]', function (e) {
            e.preventDefault();
        });

        TPS.PromotionPage.formParentSelector = formWrapper;
        if (jQuery(TPS.PromotionPage.formParentSelector).length > 0) {
            TPS.PromotionPage.setupListeners();
            if (idMe && window._tps_idme_opts) {
                TPS.PromotionPage.hasIdMe = true;
                TPS.PromotionPage.setupIdMe();
            }
        }

        if (jQuery('.pto-vehicle-item').length > 0) {
            TPS.PromotionPage.fetchVehicleDetail();
        }

        $('.js-scroll-top').click(function () { $('html,body').animate({ scrollTop: '0px' }, 800); });

    },
    setupIdMe: function () {

        var _pram_idMeCode = TPS.Util.getUrlParameter('code');
        var _pram_Error = TPS.Util.getUrlParameter('error');
        var _pram_ErrDescription = TPS.Util.getUrlParameter('error_description');

        if (_pram_idMeCode || _pram_Error) {

            if (_pram_Error) {
                // if we have an error, then
                // clear the cookies and force the user
                // to log into idme again
                TPS.Util.setCookie('idMeInfo', '')
                TPS.Util.setCookie('idMeCode', '')

            } else if (_pram_idMeCode) {

                if (_pram_idMeCode !== TPS.Util.getCookie('idMeCode')) {
                    TPS.Util.setCookie('idMeCode', _pram_idMeCode, 0.0035);
                }
            }

            TPS.PromotionPage.closeIdMePopup();
        } else {

            var _cookie_idMeCode = TPS.Util.getCookie('idMeCode');
            var _cookie_idMeInfo = TPS.Util.getCookie('idMeInfo');

            if (_cookie_idMeCode && _cookie_idMeCode !== "" && !_cookie_idMeInfo) {

                var _redirectUri = document.location.origin + document.location.pathname;

                CMSApp.AV.API.Promotion.GetPromotionUserDataFromIdMe(
                    TPS.PromotionPage.promotionGuid,
                    TPS.PromotionPage.culture,
                    _cookie_idMeCode,
                    _redirectUri,
                    // success
                    function (data) {
                        if (data.Valid) {
                            // set the idMeInfo cookie value to be
                            // the JSON data
                            TPS.Util.setCookie('idMeInfo', JSON.stringify(data), 0.0035);

                            TPS.PromotionPage.openIdMeRegistration();
                        } else {
                            // if the idme code is no longer valid (expired)
                            // clear the cookies and force the user
                            // to log into idme again
                            TPS.Util.setCookie('idMeInfo', '');
                            TPS.Util.setCookie('idMeCode', '');

                            TPS.PromotionPage.openIdMeMessage(data.ErrorMessage);

                        }
                    },
                    // fail
                    function (data) {
                        // on error clear idme cookies
                        TPS.Util.setCookie('idMeInfo', '')
                        TPS.Util.setCookie('idMeCode', '')
                        // log the error to the consol
                        console.error(data);
                    },

                );

            }


        }
    },
    setupListeners: function () {
        TPS.PromotionPage.termsLink();
        TPS.PromotionPage.setPartnerCode();
        TPS.PromotionPage.addFormFields();
    },
    setPartnerCode: function () {
        var _this = TPS.PromotionPage;

        if (TPS.PromotionPage.isHotel) {
            CMSApp.AV.API.HotelPromotion.GetAvailableHotelPartners(TPS.PromotionPage.promotionGuid, TPS.PromotionPage.culture, function (data) {
                _this.partners = data;

                _this.populatePartnerCode(_this.partners);

            }, fail)
        } else {

            CMSApp.AV.API.Promotion.GetAvailablePartners(TPS.PromotionPage.promotionGuid, TPS.PromotionPage.culture, function (data) {
                _this.partners = data;
                if ($('.site-wrapper').hasClass('lp-basic')) {
                    _this.populatePartnerCode(_this.partners);
                }
            }, fail);

            if (jQuery(TPS.PromotionPage.formParentSelector).find('#getSponsoredPartners').val() == 'true') {
                CMSApp.AV.API.Promotion.GetAvailablePartnersSponsor(TPS.PromotionPage.promotionGuid, TPS.PromotionPage.culture, function (data) {
                    _this.sponsoredPartners = data;
                }, fail);
            }
        }

        function fail(data) {
            console.log('fail');
            console.log(data);
        }


    },
    populatePartnerCode: function (data) {
        var _this = TPS.PromotionPage;
        var partnerField, parnerFieldLabel;

        if (data.length > 1) {

            var inputOptions = [];
            jQuery.each(data, function (k, v) {
                inputOptions[k] = { 'val': v.Code, 'text': v.Name };
            });

            partnerField = TPS.Forms.createFormRow(TPS.Forms.createFormField('select', 'partnerCode', '', inputOptions, window.labels.partnerSelect, window.labels.partnerValidation), true);

            jQuery(_this.formInner).prepend(partnerField);

            // if the validator has already been created
            // then append this field so it will be checked
            if (TPS.Forms.validator) {
                $('#partnerCode').rules('add',
                    {
                        required: true,
                        messages: {
                            required: window.labels.partnerValidation
                        }
                    });
            }

            // add a listener to this field so that we populate program types from the list of available program types - in case there are more than one options and it's rendered as a dropdown.
            if (!TPS.PromotionPage.isHotel) {
                $('#partnerCode').on('change', function (e) {
                    if (this.value !== '') {
                        _this.populatePinUsageDropdownBasedOnPartnerCode(this.value);
                    }
                });
            }

        } else if (data.length === 1) {

            partnerField = TPS.Forms.createFormField('hidden', 'partnerCode', data[0].Code, null);
            if (!TPS.PromotionPage.isHotel) {
                _this.populatePinUsageDropdownBasedOnPartnerCode(data[0].Code);
            }
            jQuery(_this.formInner).prepend(partnerField);

        } else {
            console.log(data);
        }


    },
    populatePinUsageDropdownBasedOnPartnerCode: function (partnerCode) {
        CMSApp.AV.API.Promotion.GetProgramsTypes(partnerCode, TPS.PromotionPage.culture, function (data) {
            var pinUsabilityDropdown = $("#pinUsability");
            pinUsabilityDropdown.html('');

            data.forEach(item => {
                $("#pinUsability").append(
                    $("<option>", { value: item.Key, text: item.Value })
                );
            });

        }, function (data) {
            console.error('failed to fetch program types');
            console.log(data);
        });
    },
    addFormFields: function () {

        CMSApp.AV.API.Promotion.LoadExtraFields(TPS.PromotionPage.promotionGuid, TPS.PromotionPage.culture, success, fail);

        function success(data) {
            var inputOptions = null;
            var formFields = jQuery(jQuery.parseXML(data)).find('field');
            jQuery.each(formFields, function (k, v) {
                if (jQuery(v).attr('visible') === 'true') {
                    var fieldLabel = jQuery(v).find('properties fieldcaption').text();
                    var fieldHint = jQuery(v).find('properties validationerrormessage').text();
                    var fieldDefaultValue = jQuery(v).find('properties defaultvalue').text();
                    var fieldCssClass = jQuery(v).find('properties fieldcssclass').text();
                    var fieldType = jQuery(v).find('settings controlname').text();
                    var fieldValueFunction = jQuery(v).find('settings ValueAccessFunctionName').text();

                    if (fieldType === 'TextBoxControl') {
                        fieldType = 'text';
                    } else if (fieldType === 'DropDownListControl') {
                        fieldType = 'select';
                        inputOptions = jQuery(v).find('settings Options').text();
                        var opts = inputOptions.split("\n");
                        inputOptions = [];
                        for (var o = 0; o < opts.length; o++)
                            inputOptions.push({ 'val': opts[o], 'text': opts[o] });
                    }

                    var fieldID = jQuery(v).attr('column');
                    var _fieldVal = '';
                    // if a default value is specified
                    // on the biz form field
                    if (fieldDefaultValue) {
                        _fieldVal = fieldDefaultValue;
                    }
                    // if a function name is specified
                    // on the biz form field
                    if (fieldValueFunction) {
                        var _setVal = TPS.PromotionPage[fieldValueFunction]();
                        if (_setVal) {
                            _fieldVal = _setVal;
                        }
                    }

                    var field = TPS.Forms.createFormField(fieldType, fieldID, _fieldVal, inputOptions, fieldLabel, fieldHint)
                    var fieldRow = TPS.Forms.createFormRow(field, true, fieldCssClass);

                    jQuery(TPS.PromotionPage.formExtraFieldsSelector).append(fieldRow);
                }
            });


            if (TPS.PromotionPage.formParentSelector) {
                TPS.Forms.setupClientValidation(TPS.PromotionPage.formParentSelector); // .generate-pin-form
            }

            TPS.PromotionPage.registerModal();

        }

        function fail(data) {
            console.log('fail');
            console.log(data);
        }

    },
    registerModal: function () {
        var _this = TPS.PromotionPage;
        var _registerModal = jQuery(_this.registrationModalSel);

        if (jQuery('#hidePreferredContactMethod').val() === 'False') {

            _this.preferredDealerPanel = $('#preferredDealerPanel');

            jQuery(document).on('change', '#zipcode, #referredZipcode', function (e) {
                var street, city, state, zipcode, country, isValidZip, _body;
                
                isValidZip = false;
                _body = {};

                if (jQuery('#allowSponsoredPin').val() === 'true' && $(this).attr('id') === 'referredZipcode') {
                    isValidZip = TPS.Forms.validator.element('#referredZipcode');
                    _body['address'] = $('#referredAddress').val();
                    _body['city'] = $('#referredCity').val();
                    _body['zip'] = $('#referredZipcode').val();
                } else if (jQuery('#allowSponsoredPin').val() !== 'true' && $(this).attr('id') === 'zipcode') {
                    isValidZip = TPS.Forms.validator.element('#zipcode');
                    _body['address'] = $('#address').val();
                    _body['city'] = $('#city').val();
                    _body['zip'] = $('#zipcode').val();
                }

                _body['country'] = jQuery('#currentCulture').val();
               
                if (_this.preferredDealerVisibility()) {
                    TPS.PromotionPage.GetPreferredRetailers(_body);
                } else {
                    jQuery("#preferredDealerID").val(0);
                    _this.preferredDealerPanel.empty();
                }
            });

            jQuery(document).on('change', '[name="preferredDealerOption"]', function (e) {
                $("#preferredDealerID").val($(this).val());
                $('#dealershipByRetailerName').val('');
                $('#selected-dealer-info').remove();
            });

            jQuery(document).on('change', 'input[id^="preferredContactMethod"]', function (e) {
                var dealersOptionsWrapper = jQuery('.options-wrapper');
                var retailerNameWrapper = jQuery('#retailerNameWrapper');

                if (_this.preferredDealerVisibility()) {
                    if (_this.preferredDealerPanel.is(':empty')) {
                        $('#zipcode').trigger('change');
                    } else {
                        dealersOptionsWrapper.removeClass('hidden');
                        retailerNameWrapper.removeClass('hidden');
                    }
                } else {
                    /*jQuery("#preferredDealerID").val(0);
                    _this.preferredDealerPanel.empty();*/
                    dealersOptionsWrapper.addClass('hidden');
                    retailerNameWrapper.addClass('hidden');
                }
            });
        }

        jQuery(document).on('click', '[data-tps-sponsored-pin]', function (e) {
            if ($(this).data('tpsSponsoredPin') == true) {
                _this.populatePartnerCode(_this.sponsoredPartners);
                jQuery(_this.formParentSelector).find('.basic-form-header-register').hide(0);
                jQuery(_this.formParentSelector).find('.sponsored-pin-section').addClass('tps-visible');
                jQuery(_this.formParentSelector).find('#allowSponsoredPin').val('true');
                jQuery(_this.formParentSelector).find('#jobTitle').hide(0);
            } else {
                _this.populatePartnerCode(_this.partners);
                jQuery(_this.formParentSelector).find('#jobTitle').show(0);
            }

        });

        jQuery(_this.formParentSelector).find('.submit-form').on('click', function (e) {
            e.preventDefault();

            //var currentFormWrapper = $(this).parents(_this.formParentSelector);

            TPS.Forms.resetMessageBlock(_this.errorBlockSelector + ', ' + _this.successBlockSelector);

            if (TPS.Forms.validator.checkForm()) {

                jQuery(_this.submitOverlaySelector).fadeIn();

                var vals = TPS.Forms.getFormVals(_this.formParentSelector);

                // get state ID from child select cms:UniSelector
                vals['stateID'] = $('#stateID').find('select').val();

                var extraFields = [];
                jQuery('.tps-additional-fields').find(":input").each(function () {
                    var o = jQuery(this);
                    if (o.attr('type') === 'radio' || o.attr('type') === 'checkbox') {
                        extraFields.push({ 'Name': o.attr('id'), 'Value': o.is(':checked') });
                    } else {
                        extraFields.push({ 'Name': o.attr('id'), 'Value': jQuery.isArray(o.val()) ? o.val().toString() : o.val() });
                    }
                });

                vals['preferredContactMethod'] = vals.hidePreferredContactMethod === 'False' ? vals['preferredContactMethod'] : '';
                
                if (vals.allowSponsoredPin === 'false' && !TPS.PromotionPage.isHotel) {
                    CMSApp.AV.API.Promotion.CreatePinCanada(
                        vals.promotionGuid,
                        vals.partnerCode,
                        vals.firstname,
                        vals.lastname,
                        vals.address,
                        vals.city,
                        vals.zipcode,
                        vals.stateID,
                        vals.emailAddress,
                        vals.phoneNumber,
                        vals.optIn,
                        vals.preferredContactMethod,
                        vals.currentCulture,
                        vals.preferredDealerID,
                        vals.pinUsability,
                        vals.jobTitle,
                        extraFields,
                        success,
                        fail
                    );

                } else if (vals.isHotelPin === 'true') {
                    // get state ID from child select cms:UniSelector
                    vals['issuanceStateID'] = $('[id*="issuanceStateID"]').find('select').val();
                    vals['currentVehicle'] = $('#currentVehicle').find('select').val();
                    vals['preferredlanguage'] = vals.currentCulture === 'en-US' ? vals.currentCulture : vals['preferredlanguage'];
                    
                    CMSApp.AV.API.HotelPromotion.CreatePin(
                        vals.promotionGuid,
                        vals.partnerCode,
                        vals.firstname,
                        vals.lastname,
                        vals.address,
                        vals.city,
                        vals.zipcode,
                        vals.stateID,
                        vals.emailAddress,
                        vals.phoneNumber,
                        vals.optIn,
                        vals.preferredContactMethod,
                        vals.driversLicenseNumber,
                        vals.issuanceStateID,
                        vals.preferredlanguage,
                        vals.preferredDealerID,
                        extraFields,
                        vals.currentVehicle,
                        vals.currentVehicleMake,
                        vals.DriveStartDate,
                        vals.DriveEndDate,
                        vals.DriveEndTime,
                        success,
                        fail);

                } else {

                    // get state ID from child select cms:UniSelector
                    vals['referredStateID'] = $('#referredStateID').find('select').val();
                    
                    CMSApp.AV.API.Promotion.CreateSponsorPin(
                        vals.promotionGuid,
                        vals.partnerCode,
                        vals.firstname,
                        vals.lastname,
                        vals.address,
                        vals.city,
                        vals.zipcode,
                        vals.stateID,
                        vals.emailAddress,
                        vals.phoneNumber,
                        vals.referredFirstname,
                        vals.referredLastname,
                        vals.referredAddress,
                        vals.referredCity,
                        vals.referredZipcode,
                        vals.referredStateID,
                        vals.referredEmail,
                        vals.referredPhone,
                        vals.optIn,
                        vals.preferredContactMethod,
                        '', // externalID
                        '', // referenceID
                        vals.currentCulture,
                        vals.preferredDealerID,
                        '', //programOption
                        extraFields,
                        success,
                        fail
                    );

                }

            } else {
                console.log(TPS.Forms.validator.numberOfInvalids() + ' validation errors');
            }
        });

        function success(data) {
            if (data.Success) {

                jQuery(_this.formInner).fadeOut(function () {

                    var successMessage = window.labels.success;

                    TPS.Forms.scrollToMessages(jQuery.parseHTML(successMessage), false, TPS.PromotionPage.successBlockSelector, '.hidden-magellan-success', true);

                    $('.sponsored-pin-headline').hide();

                    // close modal and/or reset form validation and clear form values
                    var formTimeOut = setTimeout(function () {
                        if (_registerModal.length > 0) {
                            _registerModal.foundation('close');
                        }
                        _this.resetForm();
                        $('.sponsored-pin-headline').show();
                        clearTimeout(formTimeOut);
                    }, 7500);


                });

            } else {
                TPS.Forms.scrollToMessages(data.ErrorMessages, false, TPS.PromotionPage.errorBlockSelector, '.hidden-magellan-error', false);
            }
            jQuery(TPS.PromotionPage.submitOverlaySelector).fadeOut();
        }

        function fail(data) {
            jQuery(_this.submitOverlaySelector).fadeOut(function () {
                TPS.Forms.scrollToMessages(data._statusCode + " : " + data._message, false, _this.errorBlockSelector, '.hidden-magellan-error', true);
            });
        }

        jQuery(document).on('click', '#RegisterCancel', function (e) {
            e.preventDefault();
            // close terms accordion if it exists
            if (jQuery(_this.termTextWrapperSel).length > 0) {
                jQuery(_this.termTextWrapperSel).slideUp().removeClass('active');
            }
            // close modal and/or reset form validation and clear form values
            if (_registerModal.length > 0) {
                _registerModal.foundation('close');
            } else {
                _this.resetForm();
            }

        });

        if (_registerModal.length > 0) {
            // reset form validation and clear form values when modal closes
            _registerModal.on('closed.zf.reveal', function (e) {
                _this.resetForm();
            });

            if (TPS.PromotionPage.hasIdMe) {

                // if the page uses IDme, the registration modal is blocked from opening
                // unless we have the user's idme data saved
                // otherwise we force them to login using idme
                jQuery(document).on('click', '[data-open="promo-register-form-modal-idme"]', function (e) {
                    e.preventDefault();

                    var _info = TPS.Util.getCookie('idMeInfo');
                    if (_info === false || _info === '') {
                        jQuery('.idme-trigger-link').click();
                    } else {
                        // parse the user data from the cookie
                        var _info_data = JSON.parse(_info);
                        // if the data is valid object
                        if (typeof _info_data === 'object') {

                            if (!_info_data.Valid) {
                                // if not valid, trigger a message modal
                                // and show the error from the BE
                                TPS.PromotionPage.openIdMeMessage(_info_data.ErrorMessage);
                            } else {
                                // if the user data is "valid"
                                // open the registration and populate the form
                                TPS.PromotionPage.openIdMeRegistration();
                            }
                        } else {
                            // if the data is not a valid object,
                            // force the user to log in again through idme
                            jQuery('.idme-trigger-link').click();
                        }
                    }

                });

                var _cookie_idMeInfo = TPS.Util.getCookie('idMeInfo');

                if (_cookie_idMeInfo && _cookie_idMeInfo !== '') {

                    TPS.PromotionPage.openIdMeRegistration();
                }

            }

        }
    },
    resetForm: function () {
        var _this = TPS.PromotionPage;
        var hidePreferredContactMethod = jQuery("#hidePreferredContactMethod").prop('checked');

        TPS.Forms.resetClientValidation();
        TPS.Forms.clearFormFields(_this.formParentSelector);
        TPS.Forms.resetMessageBlock(_this.errorBlockSelector + ', ' + _this.successBlockSelector);


        // remove partner code field b/c it is dynamically populated
        var partnerCode = jQuery(_this.formParentSelector).find('#partnerCode');
        var partnerCodeWrapper = partnerCode.parents('.form-control-wrapper');


        if (partnerCodeWrapper.length > 0 && !TPS.PromotionPage.isHotel) {
            partnerCodeWrapper.remove();
        } else if (!TPS.PromotionPage.isHotel) {
            partnerCode.remove();
        }

        // hide sponsored PIN fields if they are available
        jQuery(_this.formParentSelector).find('.basic-form-header-register').show(0);
        jQuery(_this.formParentSelector).find('.sponsored-pin-section').removeClass('tps-visible');
        jQuery(_this.formParentSelector).find('#allowSponsoredPin').val('false');

        if (jQuery(_this.termTextWrapperSel).length > 0) {
            jQuery(_this.termTextWrapperSel).slideUp().removeClass('active');
        }

        jQuery(_this.formInner).fadeIn();
        if (_this.preferredDealerPanel) {
            _this.preferredDealerPanel.empty();
            jQuery("#preferredDealerID").val('');
        } else {
            jQuery("#preferredDealerID").val(0);
        }
        jQuery("#hidePreferredContactMethod").prop('checked', hidePreferredContactMethod);

        //if there is a scotiabanktoken field, then set the value to the cookie
        jQuery("#ScotiabankToken").val(_this.getScotiabankToken());

    },
    termsLink: function () {

        var termTextWrapperSel = TPS.PromotionPage.termTextWrapperSel;

        if (jQuery(termTextWrapperSel).length > 0) {
            jQuery(document).on('click', '.terms-link:not(.has-href)', function (e) {

                var isAnimated = TPS.Util.checkAnimated(termTextWrapperSel);
                var isActive = TPS.Util.checkActive(termTextWrapperSel, 'active');

                if (!isActive && !isAnimated) {
                    jQuery(termTextWrapperSel).slideDown().addClass('active');
                } else if (isActive && !isAnimated) {
                    jQuery(termTextWrapperSel).slideUp().removeClass('active');
                }

            });
        }

    },
    fetchVehicleDetail: function () {

        jQuery(TPS.PromotionPage.vehcielModalSel).on('closed.zf.reveal', function (e) {
            resetVehicleModal();
        });

        jQuery(document).on('click', '.back-to-list', function (e) {
            e.preventDefault();
            resetVehicleModal();
        });

        jQuery(document).on('click', '.pto-vehicle-item', function (e) {
            e.preventDefault();
            var vehicleUrl = jQuery(this).attr('data-vehicle-detail-url');
            GetDetailContent(vehicleUrl);
        });

        function GetDetailContent(url) {

            jQuery('.vehicle-modal-detail-wrapper').empty();

            VehicleLoading(true);

            jQuery('.vehicle-modal-detail-wrapper').load(url + ' ' + TPS.PromotionPage.vehicleContentSelector, function (resp, status, xhr) {

                Foundation.reflow(jQuery('[data-tabs]'));

                jQuery('.vehicle-modal-list-wrapper').fadeOut(function () {
                    jQuery('.vehicle-get-a-pin-wrapper').empty();
                    jQuery('.vehicle-modal-detail-wrapper, .back-to-list').fadeIn();
                });

                VehicleLoading(false);

            });
        }

        function resetVehicleModal() {
            jQuery('.vehicle-modal-detail-wrapper, .back-to-list').fadeOut(function () {
                jQuery('.vehicle-modal-detail-wrapper').empty();
                jQuery('.vehicle-modal-list-wrapper').fadeIn();
            });
        }

        function VehicleLoading(start) {

            if (start) {
                jQuery('.vehicle-modal-overlay').fadeIn()
            } else {
                jQuery('.vehicle-modal-overlay').fadeOut()
            }

        }

    },
    handleDealershipByRetailerName: function () {
        var _this = TPS.PromotionPage;
        
        if ($('#dealershipByRetailerName').data('ui-autocomplete')) {
            return; // already initialized
        }

        TPS.Util.loadWebserviceJS('CMSApp.AV.API.Company');

        $('#dealershipByRetailerName').autocomplete({
            minLength: 3,
            delay: 200,
            appendTo: "#retailerNameWrapper",
            source: function (request, response) {
                var retailerName = request.term;
                var countryId = $('#currentCulture').val();

                CMSApp.AV.API.Company.SearchPreferredDealer(
                    retailerName,
                    countryId,
                    '',
                    function success(data) {
                        const suggestions = data.map(raw => {
                            const parsed = JSON.parse(raw);
                            const [dealerCode, fullAddress] = parsed.Second.split(';');
                            return {
                                label: parsed.First,
                                value: parsed.First,
                                dealerCode: dealerCode,
                                address: fullAddress
                            };
                        });
                        response(suggestions);
                    },
                    function fail(err) {
                        console.error('Search failed:', err);
                        response([]);
                    }
                );
            }
        });
        
        $('#dealershipByRetailerName').on("autocompleteselect", function (event, ui) {
            $('[name="preferredDealerOption"]').prop('checked', false);
            $('#preferredDealerID').val(ui.item.dealerCode);
            $('#selected-dealer-info').remove();
            
            const formattedAddress = ui.item.address.replace(/\\u003cbr\/\\u003e/g, '<br>');
            
            const selectedDealerHtml = `
            <div id="selected-dealer-info" class="preferred-retailer-autocomplete-selected">
                <div class="preferred-retailer-autocomplete-selected-header">
                    <strong>${window.labels.retailerAddressHeader}</strong>
                </div>
                <div id="homeshipment-retailer-address" style="margin-top: 5px;">
                    ${formattedAddress}
                </div>
            </div>
        `;
        
            $(this).after(selectedDealerHtml);
            
            if ($('#preferredDealerOption-error')) {
                $('#preferredDealerOption-error').remove();
            }
        });
    },
    GetPreferredRetailers: function (_body) {
        var _this = TPS.PromotionPage;
        
        jQuery("#preferredDealerID").val(0);
        _this.preferredDealerPanel.empty();
        
        if (_this.preferredDealerVisibility()) {
            _this.preferredDealerPanel.addClass('loading').append('<div class="loader"><div class="loader-inner"><div class="loader-inner-text"><span class="icon ion-ios-loop fa-spin loader-inner-icon"></span> ' + window.labels.RetailLocation.Loading + '</div></div></div>');
        }

        TPS.Util.loadWebserviceJS('CMSApp.AV.API.NearestDealer');

        CMSApp.AV.API.NearestDealer.GetGeolocationNearestDealersByPinAddress(
            _body.address,
            _body.city,
            _body.zip,
            _body.country,
            'APLAN',
            success,
            fail
        );

        function success(data) {
            _this.preferredDealerPanel.removeClass('loading').empty();
            
            _this.preferredDealerList = data;
            _this.renderedDealerCount = 0;
            _this.renderPreferredDealers(true);
        }

        function fail(data) {
            _this.preferredDealerPanel.removeClass('loading').empty();
            _this.preferredDealerPanel.append('<div class="no-results-message">' + data._statusCode + " : " + data._message + '</div>');
        }
    },
    renderPreferredDealers(top) {
        var _this = TPS.PromotionPage;

        var _wrapper, _fieldset, _loadMore;
        var dealersVisibility = 'hidden';

        _this.renderedDealerCount = _this.renderedDealerCount || 0;

        var start = _this.renderedDealerCount;
        var end = start + 3;
        var _dealers = _this.preferredDealerList.slice(start, end);

        if (_this.preferredDealerVisibility()) {
            dealersVisibility = '';
        }

        if (top) {
            _fieldset = $('<fieldset />').append($('<legend />').text(window.labels.RetailLocation.Choose));

            if (_this.preferredDealerList.length === 0) {
                _fieldset.append('<div class="no-results-message">' + window.labels.RetailLocation.NoLocationsFound + '</div>');
            }

            _loadMore = $('<a />')
                .attr('href', '#')
                .addClass('load-more-dealers')
                .text(window.labels.RetailLocation.LoadMore)
                .on('click', function (e) {
                    e.preventDefault();
                    _this.renderPreferredDealers(false);
                });

            _wrapper = $('<div />').addClass(`options-wrapper ${dealersVisibility}`)
                .append(_fieldset, _loadMore);

            _this.preferredDealerPanel
                .append(_wrapper)
                .append(`
                    <div id="retailerNameWrapper" class="row column form-row form-control-wrapper text-left ${dealersVisibility}">
                        <label for="dealershipByRetailerName">${window.labels.dealershipByRetailerName}</label>
                        <input name="dealershipByRetailerName" type="text" id="dealershipByRetailerName" class="form-control">
                    </div>
                `);
        } else {
            _fieldset = _this.preferredDealerPanel.find('fieldset');
        }

        $.each(_dealers, function (k, v) {
            _fieldset.append(`
                <div class="preferred-retailer-selection-item">
                    <input type="radio" name="preferredDealerOption" id="preferredDealerOption-${v.CompanyID}" value="${v.CompanyID}" />
                    <label for="preferredDealerOption-${v.CompanyID}" class="preferred-retailer-selection-item-container">
                        <span class="preferred-retailer-selection-item-info">
                            <strong class="preferred-retailer-selection-item-info-name">${v.Name}</strong>
                            <span class="preferred-retailer-selection-item-info-address">${v.Address}, ${v.City}, ${v.Zipcode}</span>
                        </span>
                        <span class="preferred-retailer-selection-item-distance">
                            <strong>${v.Distance} ${v.DistanceUnit}</strong>
                        </span>
                    </label>
                </div>
            `);
        });
        
        _this.renderedDealerCount = end;

        if (_this.renderedDealerCount >= _this.preferredDealerList.length) {
            _this.preferredDealerPanel.find('.load-more-dealers').hide();
        }
        
        if (!$('#dealershipByRetailerName').data('ui-autocomplete')) {
            _this.handleDealershipByRetailerName();
        }

        if (top) {
            if (!$('[name="preferredDealerOption"]').hasClass('validation-rule-added')) {
                $.validator.addMethod("preferredDealerRequired", function (value, element) {
                    var dealerID = $('#preferredDealerID').val();
                    return dealerID && dealerID.trim() !== "" && dealerID.trim() !== "0";
                }, window.validationMessages.preferredDealer.NoDealers);

                $('[name="preferredDealerOption"]').rules('add', {
                    preferredDealerRequired: true
                });

                $('[name="preferredDealerOption"]').addClass('validation-rule-added');
            }
        }
    },
    preferredDealerVisibility: function () {
        var isValidZip = TPS.Forms.validator.element('#zipcode');
        var selectedMethod = $('input[id^="preferredContactMethod"]:checked').val();

        if (isValidZip && selectedMethod && selectedMethod !== 'doNotContact') {
            return true;
        }
        return false;
    },
    closeIdMePopup: function () {
        // if the page has been opened in
        // the idme popup, after authentication
        if (window.opener) {
            // try to close reload the parent,
            // and close the window
            try {
                window.opener.location.reload();
                window.close();
            } catch (error) {
                console.error(error);
                throwError(`${error}`);
            }
        }
    },
    openIdMeRegistration: function () {
        var _this = TPS.PromotionPage;

        var _formModal = jQuery(_this.registrationModalSel);

        try {
            // set the partner code in the form
            _this.populatePartnerCode(_this.partners);

            var _idmeInfo = JSON.parse(TPS.Util.getCookie('idMeInfo'));

            _formModal.find('#firstname').val(_idmeInfo.FirstName);
            _formModal.find('#lastname').val(_idmeInfo.LastName);
            _formModal.find('#emailAddress').val(_idmeInfo.Email);
            _formModal.find('#zipcode').val(_idmeInfo.Zip);

            _formModal.foundation('open');

        } catch (error) {
            console.error(error);
        }


    },
    openIdMeMessage: function (message) {

        // no message is passed, then
        // get a generic message from the page
        if (!message) {
            message = window._tps_idme_opts.labels.defaultError;
        }

        // check if there is already a message reveal
        // in the dom, and if so remove it
        if (jQuery('.idme-message-reveal').length > 0) {
            jQuery('.idme-message-reveal').remove();
        }

        var _revealHtml, _reveal, _revealJq;

        _revealHtml = '<div class="idme-message-reveal reveal">';
        _revealHtml += '<a href="#" class="close promo-form-close" data-close=""><span class="icon ion-ios-close-empty" aria-hidden="true"></span><span class="sr-only">' + window._tps_idme_opts.labels.close + '</span></a>';
        _revealHtml += '<div class="callout alert">' + message + '</div>'
        _revealHtml += '</div>';

        // create the jQuery obj
        _revealJq = jQuery(_revealHtml);

        // register the modal with foundation
        _reveal = new Foundation.Reveal(_revealJq);

        // open the modal with the message
        _revealJq.foundation('open');

        // unregister the modal with foundation
        _revealJq.on('closed.zf.reveal', function () {
            _revealJq.foundation('destroy');
        });


    },
    getScotiabankToken: function () {
        return TPS.Util.getCookie('ScotiabankToken');
    }
}
